module.exports = __webpack_public_path__ + "static/media/Class5.3be70987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Class5.jpg
// module id = 348
// module chunks = 0